import React from 'react'
import UserComponent from 'components/User'
import { useUserPresenceProvider } from 'components/UserPresenceProvider'
import isFunction from 'lodash/fp/isFunction'
import * as UserPresenceStatuses from 'const/UserPresenceStatuses'
import { useSelector } from 'react-redux'
import { useUserProvider } from 'components/UserProvider'

type Props = React.ComponentProps<typeof UserComponent> & {
  id: number;
  component?: React.ComponentType<React.ComponentProps<typeof UserComponent>>;
  filter?: (user: any) => boolean;
  presence?: boolean;
}

const ControlledUser: React.FC<Props> = ({
  children,

  id,
  component: Component = UserComponent,
  filter,
  presence,

  ...props
}) => {
  useUserProvider(id)
  const userPresence = useUserPresenceProvider(id)

  const user = useSelector<any, any>(state => state.kanbo.users[id])

  const composedUserProps = {
    ...user,
    ...props,
    presence:
      presence
        ? userPresence || UserPresenceStatuses.OFFLINE
        : undefined
  }

  if (user?.isLoaded && isFunction(filter)) {
    if (!filter(user)) return null
  }

  return children ? children(composedUserProps) : <Component {...composedUserProps} />
}

export default ControlledUser
